import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  // Remove BroadcasterService from providers array since it's already provided at root level
  providers: []
})
export class BroadcasterModule { }